import { render } from "./Header.vue?vue&type=template&id=21683431&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "@/styles/header.css?vue&type=style&index=0&id=21683431&scoped=true&lang=css&external"
import "@/styles/footer.css?vue&type=style&index=1&id=21683431&scoped=true&lang=css&external"
import "@/styles/common.css?vue&type=style&index=2&id=21683431&scoped=true&lang=css&external"

import exportComponent from "../../../../../../../../../../Desktop/중요/tcd-userpage-new/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21683431"]])

export default __exports__